// extracted by mini-css-extract-plugin
export default {"root":"Disclaimer_root__FuP4+","box":"Disclaimer_box__QPcOr","container":"Disclaimer_container__GKqWd"};